<list-view [liste]="liste" *ngIf="liste"></list-view>